module.exports = __webpack_public_path__ + "static/media/favicon1.17f3ecf9.jpg";